import { render, staticRenderFns } from "./app-bar-change-password-popup.vue?vue&type=template&id=92a1faba&scoped=true&lang=pug&"
import script from "./app-bar-change-password-popup.vue?vue&type=script&lang=ts&"
export * from "./app-bar-change-password-popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a1faba",
  null
  
)

export default component.exports